import React, { Component } from 'react';
import './styles.css';
import SubmissionStepperLayout from '../SubmissionStepperLayout';

class SubmissionStepper extends Component {
	render() {
		const { game } = this.props;
		return (
			<div className="submission-stepper">
				<SubmissionStepperLayout>
					<SubmissionStepperLayout.Label />
					<SubmissionStepperLayout.Stepper game={game} />
				</SubmissionStepperLayout>
			</div>
		);
	}
}

export default SubmissionStepper;
